import React from 'react'
import { Box, Stack, IconButton, InputAdornment, Button, Divider, FormHelperText, TextField, Grid, Snackbar, Typography, Card, Container, FormControl, OutlinedInput, SvgIcon, Icon, InputLabel, FormControlLabel, Checkbox, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Link } from '@mui/material';
import SlickSlider from 'react-slick';
import { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm, register, Controller } from 'react-hook-form';
import { useSnackbar } from 'components/snackbar'
import { yupResolver } from '@hookform/resolvers/yup';
import { RegistrationSchema, OTPSchema } from '../../models/RegistrationSchema';
import { createUser, verify, removeUser } from 'api/profile';
import RegisterSection from './RegisterSection';
import Typewriter from "typewriter-effect";

import SideBanner from 'components/basic-profile/SideBannerPage';
/**
 * Register is a React component that handles the user registration process.
 * It manages the form state for user details such as full name, email, phone number,
 * password, and OTP. The component uses `react-hook-form` for form management and validation
 * using the `RegistrationSchema`. It also provides functionality to create a user account,
 * send an OTP, and handle user feedback via snackbars. Additionally, it manages the UI state
 * for showing and hiding the OTP and terms dialogs, as well as the password visibility toggle.
 * The component also includes a slider for displaying promotional text.
 */

const Register = () => {
    const [open, setOpen] = useState(false);
    const [showOTP, setShowOTP] = useState(false)
    const [userId, setUserId] = useState(null);
    const { enqueueSnackbar } = useSnackbar();
    const [email, setEmail] = useState('');

    const navigate = useNavigate();
    const { id } = useParams();
    const [showPassword, setShowPassword] = useState(false)

    const defaultValues = {
        full_name: '',
        otp: '',
        email: '',
        phone_number: '',
        password: '',
        re_password: '',
    };

    const methods = useForm({
        defaultValues,
        mode: "onChange",
        resolver: yupResolver(RegistrationSchema),
    });

    const {
        control,
        register,
        handleSubmit,
        trigger,
        setValue,
        watch,
        formState: { errors, isDirty, isValid, dirtyFields, isSubmitting },
    } = methods;

    const onSubmit = handleSubmit(async (formData) => {
        const response = await createUser(formData);
        if (response?.success === true && response.data?.id) {
            setUserId(response.data.id);
            setEmail(response.data.email);
            enqueueSnackbar(`OTP has been sent.`, { variant: 'success' })
            setShowOTP(true)
        } else {
            enqueueSnackbar(response.message, { variant: 'error' })
        }
    })

    /**
     * Opens the OTP verification dialog.
     * @function
     */
    const handleOpenOtpDialog = () => {
        setOpen(true);
    };

    /**
     * Closes the OTP verification dialog and removes the user from the database if the OTP verification fails.
     * @function
     */
    const handleClose = async () => {
        const formData = methods.getValues();
        const response = await removeUser(formData);
        if (response?.success === true) {
            setUserId(null);
            setOpen(false);
            setShowOTP(false);
        } else {
            enqueueSnackbar(response.message, { variant: 'error' })
        }
    };

    const [showFlag, setShowFlag] = React.useState(false);

    /**
     * Displays the country flag dropdown when the phone number input receives focus.
     */
    const handleFlag = () => {
        setShowFlag(true);
    }

    /**
     * Hides the flag when the phone number input field is blurred and empty.
     * Sets the showFlag state to false if phone_number is an empty string.
     */
    const handleOnBlurFlag = () => {
        if (!watch('phone_number')) {
            setShowFlag(false);
        }
    }

    /**
     * Handles input changes for phone number field.
     * Ensures the country flag is displayed when there is input.
     * @param {Object} e - The input event containing the phone number value.
     */

    const handleChange = (e) => {
        if (e.target.value.length > 0) {
            setShowFlag(true);
        } else {
            setShowFlag(true);
        }
    };
    var settings = {
        autoplay: true,
        fade: true,
        autoplaySpeed: 3000,
        speed: 1000,
        prevArrow: false,
        nextArrow: false
    };
    const [showTerm, setShowTerm] = useState(false);

    /**
     * Opens the terms and conditions dialog by setting the showTerm state to true.
     */

    const handleOpenTermsDialog = () => {
        setShowTerm(true);
    }
    /**
     * Closes the terms and conditions dialog by setting the showTerm state to false.
     */
    const handleCloseTermsDialog = () => {
        setShowTerm(false);
    }

    return (
        <Box sx={{ overflow: 'hidden' }}>
            <Grid container justifyContent={'center'} alignItems={'center'}>
                <Grid item xs={12} md={6} lg={6}>
                    <RegisterSection />
                </Grid>
                <Grid item xs={12} md={6} lg={6} sx={{ display: { xs: 'none', md: 'block' } }}>
                    <SideBanner />
                </Grid>
            </Grid>
        </Box>
    )
}
export default Register;